import useDataLoader from 'data-loader';

export default useDataLoader;
